let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("klHyh")).then(() => parcelRequire('8Jdvp'));